import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Panel, ModuleHeader } from "@/components/kcc/Panel";
import { StatusChip } from "@/components/kcc/Kpi";

export default function Notifications() {
    const [data, setData] = useState({ items: [], count: 0 });
    useEffect(() => { api.get("/notifications").then(({ data }) => setData(data)); }, []);
    return (
        <div className="space-y-6">
            <ModuleHeader kicker="Notification Centre" title="Enterprise Alerts" description="Cross-module notifications from Tailings360, Safety360, Maintenance360, Environment360 and Security360 — with severity, acknowledgment and audit trail." />
            <Panel title={`${data.count} active notifications`} accent="amber">
                <div className="space-y-2">
                    {data.items.map((n) => (
                        <div key={n.id} className="flex items-start gap-3 p-3 rounded border border-white/5 hover:border-white/15 bg-white/[0.02]" data-testid={`notif-${n.id}`}>
                            <StatusChip status={n.severity === "critical" ? "critical" : n.severity === "warning" ? "warning" : "info"}>{n.module}</StatusChip>
                            <div className="flex-1 min-w-0">
                                <div className="text-sm text-white">{n.title}</div>
                                <div className="text-[11px] kcc-text-silver">{n.detail}</div>
                            </div>
                            <div className="text-[11px] kcc-text-dim">{n.ts}</div>
                        </div>
                    ))}
                    {!data.items.length && <div className="text-sm kcc-text-dim italic p-4 text-center">Nothing to escalate right now.</div>}
                </div>
            </Panel>
        </div>
    );
}
